import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/three_terminal/es/base/publicMethod';
import styles from './index.css';
import Chip from 'Chip';

import Ad from '@ifeng-fe/ui_pc_ad';

import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

import { Caption, SlidesTabs, HomeFooter, Copyright } from '@ifeng-fe/three_terminal/es/mobile/index';
import Header from './header';
import Content from './content';
import Footer from './footer';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const { videoNavigation, columnId, videoStream, streamAd } = content;
        const contentData = {
            videoStream,
        };

        return (
            <Fragment>
                <Header />
                <Chip
                    id="50182"
                    type="struct"
                    title="视频导航"
                    groupName="header"
                    translate="handleHomeNavInfo"
                    content={videoNavigation}>
                    <SlidesTabs content={videoNavigation} currentPath={columnId} />
                </Chip>
                <Content content={contentData} ad={streamAd} columnId={columnId} />
                <ChipEdit transform={transform} />
                <Footer />
            </Fragment>
        );
    }
}

export default Layout;
